export default __webpack_public_path__ + "static/images/83c49ecfbbee3da70cd64a615fcda479.png";